import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Slider,
  Tabs,
  Tab,
  Box,
  Typography,
  Divider,
  Tooltip,
} from "@mui/material";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import JSONEditor from 'jsoneditor';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faTrash,
  faCaretRight,
  faPlus,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { GradientCircularProgress } from '../Loader';
import { Modal } from "@mui/material";
import JsonEdit from './JsonEdit';
// import JsonSchemaValidator from './SchemaValidator';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import _save from '../../assets/save.svg';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  pt: 2,
  paddingLeft: 0,
  paddingRight: 0,
};

// import PDFViewer from './PDFViewer';
export default function FileEditor({
  handleCloseFileAnnotator,
  selectedFileUrl,
  setSelectedFile,
  handleFileSelect,
  searchFileName,
  setSearchFileName,
  triggerAlert,
  sectionJSONData,
  setSectionJsonData,
  setTextSections,
  textAreaData,
  setTextAreaData,
  selectedTextSection,
  setSelectedTextSection,
  textSections,
  handleSectionSelection,
  setLoading,
  loading,
  setSchemaJsonList,
  schemaJsonList,
  getCollectionSchemaData,
  schemaResult,
  handleSaveAnnotation,
  editorRef,
  collectionId,
  jsonSections
}) {
  const [zoom, setZoom] = useState(100);
  const [view, setView] = useState("pdfView");
  const [rightView, setRightBView] = useState("jsonText");
  const [leftWidth, setLeftWidth] = useState(70);
  const [isDragging, setIsDragging] = useState(false);
  const [openSchema, setOpenSchema] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({});
  const [newRowData, setNewRowData] = useState({});
  const [enableSecEditor, setEnableSecEditor] = useState(false)
  const [renderKey, setRenderKey] = useState(0);
  const containerRef = useRef(null);
  const schemaEditorRef = useRef(null);

  const [editingCell, setEditingCell] = useState(null); // Track which cell is being edited



  const handleOpenSchema = () => {
    setOpenSchema(true)
  }



  const handleCloseSchema = () => {
    setOpenSchema(false)
  }



  const handleMouseDown = (e) => {
    setIsDragging(true);
    // Disable pointer events on iframe during dragging
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.pointerEvents = 'none'; // Prevent iframe from capturing mouse events
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    // Re-enable pointer events on iframe after dragging
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.pointerEvents = 'auto'; // Allow iframe to capture mouse events again
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newWidth = (e.clientX / window.innerWidth) * 100;
    if (newWidth > 25 && newWidth < 75) setLeftWidth(newWidth);
  };

  const validateJsonAgainstSchema = (json, schema, path = "") => {
    const errors = [];
  
    if (!schema || !schema.type || typeof schema !== "object") {
      return errors;
    }
  
    if (schema.type === "object" && schema.properties) {
      const jsonKeys = Object.keys(json || {});
      const schemaKeys = Object.keys(schema.properties);
  
      // Check for missing required fields
      if (schema.required) {
        schema.required.forEach((requiredKey) => {
          if (!jsonKeys.includes(requiredKey)) {
            errors.push({
              path: [...path.split("."), requiredKey].filter(Boolean),
              message: `Missing required field: "${requiredKey}".`,
            });
          }
        });
      }
  
      // Check for extra fields in JSON
      jsonKeys.forEach((key) => {
        if (!schemaKeys.includes(key)) {
          errors.push({
            path: [...path.split("."), key].filter(Boolean),
            message: `Unexpected field: "${key}".`,
          });
        }
      });
  
      // Validate each key in the JSON against the schema
      schemaKeys.forEach((key) => {
        if (json && json[key] !== undefined) {
          errors.push(
            ...validateJsonAgainstSchema(
              json[key],
              schema.properties[key],
              `${path ? `${path}.` : ""}${key}`
            )
          );
        }
      });
    } else if (schema.type === "array" && Array.isArray(json)) {
      // Validate arrays
      json.forEach((item, index) => {
        errors.push(
          ...validateJsonAgainstSchema(
            item,
            schema.items,
            `${path ? `${path}.` : ""}${index}`
          )
        );
      });
    } else if (schema.type && typeof json !== schema.type) {
      // Validate type mismatch
      errors.push({
        path: path ? path.split(".") : [],
        message: `Type mismatch at "${path || "root"}". Expected "${schema.type}", found "${typeof json}".`,
      });
    }
  
    return errors;
  };

  
  useEffect(() => {
    if (containerRef.current) {
      const options = {
        modes: ["tree"],
        onBlur: () => {
          if (editorRef && editorRef.current) {
            try {
              const updatedJson = editorRef?.current?.get();
              setSectionJsonData(updatedJson);
            } catch (error) {
              console.error("Invalid JSON", error);
            }
          }
        },
        schema: schemaJsonList[selectedTextSection]?.schema || {}, // Schema for validation
        allowSchemaSuggestions: true,
        search: true,
        statusBar: true,
  
        // Custom validation function
        onValidate: (json) => {
          const schema =
            schemaJsonList[selectedTextSection]?.schema || {};
  
          const validationErrors = validateJsonAgainstSchema(json, schema);
  
          // Convert to JSONEditor error format
          return validationErrors.map((error) => ({
            path: error.path,
            message: error.message,
          }));
        },
      };
  
      editorRef.current = new JSONEditor(containerRef.current, options);
      editorRef.current.set(sectionJSONData);
  
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.expandAll();
        }
      }, 1);
    }
  
    // Remove unwanted buttons
    const unwantedSelectors = [
      ".jsoneditor-transform",
      ".jsoneditor-sort",
      ".jsoneditor-modes",
    ];
    unwantedSelectors.forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) element.remove();
    });
  
    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
    };
  }, []); // Runs only once for initialization
  
  useEffect(() => {
    if (editorRef.current) {
      // Dynamically update schema and data
      editorRef.current.setSchema(
        schemaJsonList[selectedTextSection]?.schema || {}
      );
      editorRef.current.set(sectionJSONData);
      editorRef.current.expandAll();
    }
  }, [sectionJSONData, selectedTextSection, openSchema, schemaJsonList]); // Runs on dependency change
  

  const handleToggleCollapse = (path) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [path]: !prev[path]
    }));
  };


  const handleDeleteRow = (path, index) => {
    setSectionJsonData(prevData => {
      const updatedData = { ...prevData };
      const keys = path.split(".");
      let current = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];

      if (Array.isArray(current[lastKey])) {
        current[lastKey] = [...current[lastKey]]; // Clone the array
        current[lastKey].splice(index, 1); // Remove the row
      } else {
        console.error("Expected an array, but got:", current[lastKey]);
      }

      return updatedData;
    });
  };

  const handleAddRow = (path, newRow) => {
    setSectionJsonData(prevData => {
      const updatedData = { ...prevData };
      const keys = path.split(".");
      let current = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {}; // Ensure each level exists
        }
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];

      if (!current[lastKey]) {
        current[lastKey] = []; // Initialize as array if undefined
      }

      if (Array.isArray(current[lastKey])) {
        current[lastKey] = [...current[lastKey], newRow]; // Clone & append row
      } else {
        console.error("Expected an array, but got:", current[lastKey]);
      }

      return updatedData;
    });
  };


  const handleChange = (path, value) => {
    setSectionJsonData(prevData => {
      const updatedData = { ...prevData };
      const keys = path.split(".");
      let obj = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (obj[keys[i]] === undefined || obj[keys[i]] === null) {
          // If at any point the object is undefined or null, return early
          return updatedData;
        }
        obj = obj[keys[i]];
      }
      if (obj && obj.hasOwnProperty(keys[keys.length - 1])) {
        obj[keys[keys.length - 1]] = value;
      }

      return { ...updatedData };
    });
  };


  const handleCellDoubleClick = (path, index, field) => {
    setEditingCell({ path, index, field });
  };

  const handleSaveCell = (path, index, field, newValue) => {
    setSectionJsonData(prevData => {
      const updatedData = { ...prevData };
      const keys = path.split(".");
      let current = updatedData;

      // Navigate through the keys
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }

      // Ensure the value exists before updating
      if (current && current[index] && current[index].hasOwnProperty(field)) {
        current[index][field] = newValue;
      }

      return updatedData;
    });
    setTimeout(() => {
      setEditingCell(null); // Reset the editing state after saving
    }, 0);   
  };

  const handleConvertAndSave = (newValue, expectedType) => {
    try {
      // Try converting the value to the expected type
      if (expectedType === 'number') {
        const convertedValue = Number(newValue);
        if (isNaN(convertedValue)) throw new Error("Invalid number");
        return convertedValue;
      }
      if (expectedType === 'boolean') {
        const convertedValue = newValue.toLowerCase() === 'true';
        return convertedValue;
      }
      if (expectedType === 'date') {
        const convertedValue = new Date(newValue);
        if (isNaN(convertedValue.getTime())) throw new Error("Invalid date");
        return convertedValue;
      }
      return newValue; // return as is if no conversion needed
    } catch (error) {
      alert(`Conversion failed: ${error.message}`);
      return newValue; // return the original value in case of failure
    }
  };

  function isNumber(str) {
    if (typeof str !== "string") {
      return false;
    }

    return !isNaN(str) && !isNaN(parseFloat(str));
  }


  const renderForm = (data, path = "") => {
    if (typeof data === "object" && data !== null) {
      return Object.entries(data).map(([key, value]) => {
        const newPath = path ? `${path}.${key}` : key;
        const isCollapsed = collapsedSections[newPath] || false;

        if (Array.isArray(value)) {
          const isObjectArray = value.length > 0 && value.every(item => typeof item === "object" && item !== null);

          // Case 1: Array of primitive values with the same data type
          const allValuesSameType = value.length > 0 && value.every(item => typeof item === typeof value[0]);

          if (!isObjectArray && allValuesSameType) {
            let indxPath = newPath.replace('.', '_')
            return (
              <div key={newPath} className="mb-4">
                <label className="w-full block font-bold mb-1">{key}:</label>
                <table className="w-full border-collapse border bg-white">
                  <tbody>
                    {value.map((item, index) => (
                      <tr key={index}>
                        <td className="border p-2">
                          <input
                            type={typeof value[0] == 'number' ? value[0] : 'text'}
                            value={item || ''}
                            onChange={(e) => {
                              const updatedArray = [...value];
                              updatedArray[index] = e.target.value
                              handleChange(newPath, updatedArray);
                            }}
                            className="w-full p-1 border rounded"
                          />
                        </td>
                        <td className="border p-2 td-controller">
                          <button
                            onClick={() => handleDeleteRow(newPath, index)}
                            className="text-red-600 td-delete-button"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    ))}
                    {/* Render a new row with input fields */}
                    <tr>
                      <td className="border p-2">
                        <input
                          type={typeof value[0] == 'number' ? 'number' : 'text'}
                          value={newRowData && newRowData[indxPath] || ""}
                          onChange={(e) => {
                            setNewRowData({ ...newRowData, [indxPath]: e.target.value })
                          }}
                          className="w-full p-1 border rounded"
                        />
                      </td>
                      <td className="border td-controller">
                        <button
                          onClick={() => {
                            try {
                              if (newRowData[indxPath] == undefined || String(newRowData[indxPath]).length == 0) {
                                triggerAlert('error', 'Values should not be empty/Wrong input')
                              } else {
                                let typeChangedVal = handleConvertAndSave(newRowData[indxPath], typeof value[0] == 'number' ? 'number' : 'string');
                                handleAddRow(newPath, typeChangedVal);
                                setNewRowData({}); // Clear the input fields after adding the row
                              }
                            } catch (e) {
                              triggerAlert('error', 'Values should not be empty/Wrong inputasdfsdfds')
                            }
                          }}
                          className="text-blue-600 td-submit-button"
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          }

          // Case 2: Array of values with different data types (use textarea with newlines)
          if (!isObjectArray && !allValuesSameType) {
            return (
              <div key={newPath} className="mb-4">
                <label className="w-full block font-bold mb-1">{key}:</label>
                <textarea
                  value={value.join("\n") || ''} // Join array values with newline characters
                  onChange={(e) => {
                    const newValue = e.target.value.split("\n").map(item => {
                      return isNumber(item.trim()) ? Number(item.trim()) : item.trim()
                    }
                    ); // Split input back to array
                    handleChange(newPath, newValue);
                  }}
                  className="w-full p-2 border border-gray-300 rounded"
                  rows="3" // Default height for 3 rows
                  style={{
                    width: '100%',
                    maxHeight: '100px', // Set the maximum height
                    overflowY: 'auto', // Enable vertical scroll when content exceeds maxHeight
                  }}
                />
              </div>
            );
          }

          // Case 3: Array of objects (render as table)
          if (isObjectArray) {
            let indxPath = newPath.replace('.', '_')
            return (
              <div key={newPath} className="mb-4 border p-2 bg-gray-100 rounded">
                <div className="flex justify-between items-center mb-2">
                  <button
                    className="text-blue-600 expand-button"
                    onClick={() => handleToggleCollapse(newPath)}
                  >
                    {isCollapsed ? (
                      <FontAwesomeIcon color="red" icon={faCaretRight} />
                    ) : (
                      <FontAwesomeIcon color="green" icon={faCaretDown} />
                    )}
                  </button>
                  <u>
                    <strong className="text-lg text-gray-800">{key} [{value.length}]:</strong>
                  </u>
                </div>

                {!isCollapsed && (
                  <div className="ml-4">
                    <table className="border-collapse border bg-white">
                      <thead>
                        <tr className='td-controller'>
                          {Object.keys(value[0]).map(field => (
                            <th key={field} className="border bg-gray-200" title={`${field}`}>{field}</th>
                          ))}
                          <th className="border bg-gray-200 td-controller">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.map((obj, index) => (
                          <tr key={index}>
                            {Object.entries(obj).map(([field, fieldValue]) => (
                              <td
                                key={field}
                                className="border"
                                title={`${fieldValue}`}
                                onDoubleClick={() => handleCellDoubleClick(newPath, index, field)}
                              >
                                {editingCell?.path === newPath &&
                                  editingCell?.index === index &&
                                  editingCell?.field === field ? (
                                  <input
                                    type="text"
                                    value={fieldValue || ''} // Ensure fieldValue is not undefined
                                    onChange={(e) => {
                                      handleChange(`${newPath}.${index}.${field}`, e.target.value);
                                    }}
                                    autoFocus
                                    className="border rounded"
                                  />
                                ) : (
                                  fieldValue || '—' // Display '—' if fieldValue is undefined
                                )}
                              </td>
                            ))}
                            <td className="border td-controller">
                              {editingCell?.path === newPath &&
                                editingCell?.index === index ? (
                                <button
                                  onClick={() => {
                                    handleSaveCell(newPath, index, editingCell.field, obj[editingCell.field]);
                                  }}
                                  className="text-green-600 td-submit-button"
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              ) : (
                                <button
                                  className="td-delete-button"
                                  onClick={() => handleDeleteRow(newPath, index)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                        {/* Render a new row with input fields */}
                        <tr>
                          {Object.keys(value[0]).map((field, index) => (
                            <td key={index} className="border p-2">
                              <input
                                type="text"
                                value={newRowData[indxPath] && newRowData[indxPath][field] || ""}
                                onChange={(e) => {
                                  let objData = newRowData[indxPath]
                                  setNewRowData({ [indxPath]: { ...objData, [field]: e.target.value } })
                                }}
                                className="w-full p-1 border rounded"
                              />
                            </td>
                          ))}
                          <td className="border p-2 td-controller">
                            <button
                              onClick={() => {
                                handleAddRow(newPath, newRowData[indxPath]);
                                setNewRowData({}); // Clear the input fields after adding the row
                              }}
                              className="text-blue-600 td-submit-button"
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          }
        }

        if (typeof value === "object" && value !== null) {
          return (
            <div key={newPath} className="mb-4 border p-2 bg-gray-100 rounded">
              <div className="flex justify-between items-center mb-2">
                <button
                  className="text-blue-600 expand-button"
                  onClick={() => handleToggleCollapse(newPath)}
                >
                  {isCollapsed ? (
                    <FontAwesomeIcon color="red" icon={faCaretRight} />
                  ) : (
                    <FontAwesomeIcon color="green" icon={faCaretDown} />
                  )}
                </button>
                <u>
                  <strong className="text-lg text-gray-800">{key} [{Object.keys(value).length}]:</strong>
                </u>
              </div>

              {!isCollapsed && (
                <div className="ml-4">
                  {renderForm(value, newPath)}
                </div>
              )}
            </div>
          );
        }

        return (
          <div key={newPath} className="mb-4">
            <label className="w-full block font-bold mb-1">{key}:</label>
            <textarea
              value={value || ''} // Ensure value is not undefined
              onChange={(e) => handleChange(newPath, e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
              rows="3"
              style={{ width: '100%', height: '50px' }}
            />
          </div>
        );
      });
    } return '';
  };




  return (
    <Box className='file-editor-container' sx={{ display: "flex", width: "100vw", height: "100vh", overflow: "hidden" }} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
      <Box sx={{ width: `${leftWidth}%`, padding: 2 }}>

        {/* <div className='left-editor-header'>
          <TextField value={searchFileName} onChange={(e) => setSearchFileName(e.target.value)} size='small' className='file-search-input' placeholder="Enter path to fullText directory" />
          <Button className='submit-button' onClick={handleFileSelection} color='success' variant="contained">Submit</Button>
        </div> */}

        <div className='left-editor-header'>
          <Tabs value={view} onChange={(e, newView) => setView(newView)} sx={{ mt: 1 }} className='editor-tabls-container'>
            <Tab className='tab-items' label="Pdf" value="pdfView" />
            <Tab className='tab-items' label="Full Text" value="fullText" />
            <Tab className='tab-items' label="Sec Text" value="secText" />
          </Tabs>
          <div className='section-schema'>
            <Button variant="contained" disabled={schemaEditorRef == null} style={{ width: '142px' }} onClick={handleOpenSchema}>Schema Editor</Button>
          </div>
        </div>
        {loading && (<div className="pdf-viwer-container-loader">
          <GradientCircularProgress />
        </div>
        )}
        <Box className='pdf-viwer-container' style={{ overflow: view === 'secText' ? '' : 'auto' }}>
          <iframe
            style={{ display: view === 'pdfView' ? 'block' : 'none' }}
            className='pdf-viewer'
            src={selectedFileUrl}
            frameborder="0"
            height="500px"
            width="100%"
          ></iframe>
          {view === 'fullText' ? (
            <div className='text-view-container'>
              <Box sx={{ width: "100%", p: 0, display: 'flex', flexDirection: 'column', height: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 0,
                    width: '100%',
                    margin: '0.95% 0%',
                    zIndex: 10, // Keep slider on top
                  }}
                >
                  <Typography sx={{ mr: 2 }}>Zoom:</Typography>
                  <Slider
                    value={zoom}
                    onChange={(e, newValue) => setZoom(newValue)}
                    min={50} // Min zoom 50%
                    max={200} // Max zoom 200%
                    step={10} // Increment by 10%
                    sx={{ width: 200 }}
                  />
                  <Typography sx={{ ml: 2 }}>{zoom}%</Typography>
                </Box>

                {/* Text Viewer */}
                <Box
                  sx={{
                    p: 2,
                    border: "1px solid #ccc",
                    background: "#f9f9f9",
                    flexGrow: 1, // This ensures the box takes the remaining available space
                    overflow: "auto", // Ensure scrolling
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap", // Preserve newlines and spaces
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: `${zoom}%`, // Zooms the text based on the slider value
                      whiteSpace: "pre-wrap", // Preserve formatting and spaces
                    }}
                  >
                    {textAreaData && textAreaData.length > 0 ? textAreaData : <div className='empty-data-message'>No data Found</div>}
                  </Typography>
                </Box>
              </Box>
            </div>
          ) : view === 'secText' &&
          <>
            <div className='text-view-container'>
              <Box sx={{ width: "100%", p: 0, display: 'flex', flexDirection: 'column', height: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 0,
                    width: '100%',
                    zIndex: 10, // Keep slider on top
                  }}
                >
                  <Typography sx={{ mr: 2 }}>Zoom:</Typography>
                  <Slider
                    value={zoom}
                    disabled={enableSecEditor}
                    onChange={(e, newValue) => setZoom(newValue)}
                    min={50} // Min zoom 50%
                    max={200} // Max zoom 200%
                    step={10} // Increment by 10%
                    sx={{ width: 200 }}
                  />
                  <Typography sx={{ ml: 2 }}>{zoom}%</Typography>

                  <select className='section-selector' value={selectedTextSection} onChange={(e) => handleSectionSelection(e.target.value)}>
                    <option className='menu-option' value="">Select Section</option>
                    {textSections.map((section, index) =>
                      <option key={`text-section-option${index}`} className='menu-option' value={index}>Section {index + 1}</option>
                    )}
                  </select>
                  <FormControlLabel
                    value={enableSecEditor}
                    control={<Switch color="primary" disabled={!(textSections[selectedTextSection] && textSections[selectedTextSection].length > 0)} onClick={() => setEnableSecEditor(!enableSecEditor)} />}
                    label="Edit"
                    labelPlacement="end"
                    className='edit-switch'
                  />
                  <Tooltip title="Save">
                    <button className={`${!enableSecEditor ? 'disabled-save-button' : 'save-button'}`} style={{ opacity: !enableSecEditor ? '0.5' : '1' }} disabled={!enableSecEditor} onClick={() => handleSaveAnnotation('text')}>
                      <img
                        src={_save}
                        alt="Save"
                        className="save-icon"
                      />
                    </button>
                  </Tooltip>
                </Box>
                {enableSecEditor ?
                  <div className='text-view-container' style={{
                    marginTop: '7px'
                  }}>
                    <textarea
                      className='text-file-viewer'
                      name="file-text"
                      value={textSections[selectedTextSection]}
                      onChange={(e) =>
                        setTextSections((prevItems) =>
                          prevItems.map((item, i) => (i === selectedTextSection ? e.target.value : item))
                        )
                      }
                    />
                  </div>
                  : <Box
                    sx={{
                      p: 2,
                      border: "1px solid #ccc",
                      background: "#f9f9f9",
                      flexGrow: 1, // This ensures the box takes the remaining available space
                      overflow: "auto", // Ensure scrolling
                      marginTop: '7px', // Add margin to separate from the zoom slider
                      lineHeight: 1.6,
                      whiteSpace: "pre-wrap", // Preserve newlines and spaces
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: `${zoom}%`, // Zooms the text based on the slider value
                        whiteSpace: "pre-wrap", // Preserve formatting and spaces
                      }}
                    >
                      {textSections[selectedTextSection] && textSections[selectedTextSection].length > 0 ? textSections[selectedTextSection] : <div className='empty-data-message'>No data Found</div>}
                    </Typography>
                  </Box>
                }
              </Box>
            </div>
          </>
          }
        </Box>

      </Box>

      <Divider orientation="vertical" flexItem className='editor-drager' sx={{ cursor: "ew-resize", width: "8px", background: "#6200ea", display: "flex", alignItems: "center", justifyContent: "center" }} onMouseDown={handleMouseDown}>
        <DragIndicatorIcon sx={{ color: "white" }} />
      </Divider>

      {/* ---------------------------right side--------------------------------- */}
      <Box sx={{ flexGrow: 1, borderLeft: "1px solid #ddd" }} className='json-form-editor' style={{ width: `${window.innerWidth - (window.innerWidth * (leftWidth / 100))}px`, overflow: 'scroll' }}>
        <div className='close-btn-div'>
          <Tooltip title="Save">
            <button className='save-button-json' onClick={() => handleSaveAnnotation('json')}>
              <img
                src={_save}
                alt="Save"
                className="save-icon"
              />
            </button>
          </Tooltip>
          <button className='close-button' onClick={handleCloseFileAnnotator}><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <Tabs value={rightView} onChange={(e, newView) => { setEnableSecEditor(false); setRightBView(newView) }} sx={{ mt: 1 }} className='json-form-tab-container'>
          <Tab className='tab-items' label="Json" value="jsonText" />
          {schemaJsonList && schemaJsonList[selectedTextSection] && schemaJsonList[selectedTextSection]?.schema && Object.keys(schemaJsonList[selectedTextSection]?.schema).length != 0 && sectionJSONData && Object.keys(sectionJSONData).length > 0 && <Tab className='tab-items' label="Form" value="formText" />}
        </Tabs>
        <Box className='json-form-edit-box'>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>

            <div className="max-w-[600px] mx-auto text-center" style={{ display: rightView == 'jsonText' ? 'block' : 'none' }}>
              {!(schemaJsonList && schemaJsonList[selectedTextSection] && schemaJsonList[selectedTextSection]?.schema && Object.keys(schemaJsonList[selectedTextSection]?.schema).length != 0) && <div className='schema-compare-error'>Schema Not Found</div>}
              {!(jsonSections && jsonSections.length > 0) && <div className='empty-data-message'>No data Found</div>}
              <div ref={containerRef} key={renderKey} className="w-full h-full" style={{ display: jsonSections && jsonSections.length > 0 ? 'block' : 'none' }}></div>
            </div>
            {loading && (<div className="pdf-viwer-container-loader">
              <GradientCircularProgress />
            </div>
            )}
            <div className="max-w-xl mx-auto text-left font-sans dynamic-form-render" style={{ display: rightView == 'jsonText' ? 'none' : 'block' }}>
              <h2 className="text-gray-700 mb-2 text-2xl font-semibold">Form Editor</h2>
              <div className="text-left px-2 mx-2 py-2 border border-gray-300 rounded bg-white">
                {renderForm(sectionJSONData)}
              </div>
            </div>
            <div className='update-buttons-bottom'>
            </div>
            {(jsonSections && jsonSections.length > 0) && <pre style={{ textAlign: "left", marginTop: "10px", background: "#f4f4f4", padding: "10px" }}>
              {JSON.stringify(sectionJSONData, null, 2)}
            </pre>}
          </Typography>
        </Box>
      </Box>
      <Modal
        open={openSchema}
        onClose={handleCloseSchema}
        aria-labelledby="schema-editor-title"
        aria-describedby="schema-editor-description"
        className="schema-editor-modal-container"
      >
        <JsonEdit sectionJSONData={sectionJSONData} handleCloseSchema={handleCloseSchema} schemaJsonList={schemaJsonList} setSchemaJsonList={setSchemaJsonList} getCollectionSchemaData={getCollectionSchemaData}
          schemaEditorRef={schemaEditorRef}
        />
      </Modal>
    </Box>
  );
}
